module.exports = __webpack_public_path__ + "img/icon-mail-2.007ec083.svg";